import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useIntl, connect, withRouter } from 'umi';
import moment from 'moment';
import { Popover, List, Bubble } from 'tea-component';
import {
  parseUrlInfo,
  getPathFromDashboard,
  matchPathWithDashboard,
} from '@/pages/dashboard/utils/utils';
import { subscribeNotManagePath, subscribePath, whiteListOfRoutePath } from '@/pages/dashboard/_config/routers';
import HeaderNav from '@/pages/dashboard/components/Navigation/HeaderNav';
import NavigaMenu from '@/pages/dashboard/components/Navigation/menu';
import ModalWrap from '@/pages/dashboard/components/LeftMenu/components/ModalWrap';
import SvgIcon from '@/pages/home/components/SvgIcon';
import {
  DOWNLOAD_GUIDE_LINK,
  MENU_PERMISSION,
  MENU_CONTROL_PERMISSION,
  PAGE_TYPE_OUT_URL,
  PAGE_TYPE_OUT_PATH,
  SHOW_DOWNLOAD_GUIDE,
} from '@/pages/dashboard/_config/constant';
import {
  findPathTypeAndValue,
  getFooterLinkConfig,
  openFooterLink,
} from './utils';
import { getLanguage } from '@home/utils/common';
import { isEmpty } from 'lodash-es';
import '@/pages/dashboard/assets/scss/components/navigation/navigation.scss';
import HomeLeftMenu from '@/pages/home/components/LeftMenu';
import './index.scss';
import { getPathValidity } from '@/pages/dashboard/services/leftMenu';
import { LANGUAGE_EN } from '@home/_config/config';

export interface ModalInfoType {
  show: boolean;
  type: 'add' | 'edit' | '';
  editType: 'menu' | 'subfolder' | 'folder' | 'dashboard' | 'access_denied' | '';
  item?: any;
}

const initModalInfo: ModalInfoType = {
  show: false,
  type: 'add',
  editType: '',
};

const LeftMenu = withRouter((props: any) => {
  // 控制大小宽度切换 true是正常
  const { formatMessage, locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isNormal, setNormal] = useState(true);
  const [modalInfo, setModalInfo] = useState<ModalInfoType>(initModalInfo);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const splitterRef = useRef<HTMLDivElement>(null);
  // const history = props.history;
  // 选中菜单底部样式
  const [activeIndex, setActiveIndex] = useState('');
  const title = formatMessage({ id: 'dashboard' });
  useEffect(() => {
    const resizeEvent = new Event('resize');
    window.dispatchEvent(resizeEvent);
  }, [isNormal]);

  const {
    currentGame,
    menuList,
    dashboardList,
    currentMenu,
    menuLoading,
    gameList,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    showContentMask,
    dispatch,
    location,
    history,
    subscribleEnable,
  } = props;

  const pathPermissionCheckKeyRef = useRef<string>('');

  const findInnerDashboard = (dashboardList: any[], excludePathname?: string) => {
    return dashboardList.find((item: any) => {
      if ([PAGE_TYPE_OUT_URL, PAGE_TYPE_OUT_PATH].includes(item.page_type)) {
        return false;
      }
      const itemPath = (getPathFromDashboard(item) || '').split('?')[0];
      if (excludePathname && itemPath === excludePathname) {
        return false;
      }
      return true;
    });
  };

  // 根据URL查询当前的menu
  const checkMenuWitchPath = () => {
    const { realPath = '' } = parseUrlInfo(history.location.pathname);
    if (!realPath) {
      return;
    }
    // 带 query 参数的完整路径，用于匹配 path 中带 query 的菜单项（如 /auth_path?xxx=abc）
    const realPathWithSearch = realPath + (history.location.search || '');
    // 从dashboard查找匹配的menu（先用不含query的路径匹配，再用含query的路径匹配）
    const findMenu = dashboardList.find((item: any) => matchPathWithDashboard(item, realPath))
      || dashboardList.find((item: any) => matchPathWithDashboard(item, realPathWithSearch));
    // 无currentMenu，或者当前url和menu不匹配
    // if (!currentMenu || !matchPathWithDashboard(currentMenu, realPath)) {
    if (!currentMenu || findMenu !== currentMenu) {
      // 如果查到，更新currentMenu
      if (findMenu) {
        dispatch({
          type: 'dashboard/save',
          payload: {
            currentMenu: findMenu,
          },
        });
      } else {
        // 如果处于订阅页面，则切换到另一个游戏，如果没有订阅的权限，则默认跳转第一个dashboard
        const notShowSubscribe= subscribePath?.includes(realPath) && !subscribleEnable;
        const isHaveQuery =  isEmpty(history?.location?.query as any);
        // 具有订阅的权限，并且是订阅设置和订阅记录页面，如果url没有参数（切换游戏的时候），则跳转游戏的第一个页面
        const subcribeNeedJump = subscribeNotManagePath?.includes(realPath) && subscribleEnable && isHaveQuery;
        // 无权限时跳过当前页，落到下一个非外链菜单，避免 replace 回自身死循环
        const findDashboard = findInnerDashboard(dashboardList, realPath);
        const canFallback = !!findDashboard || !!findInnerDashboard(dashboardList);

        if ((!whiteListOfRoutePath.includes(realPath) || notShowSubscribe || subcribeNeedJump) && canFallback) {
          const game_code = currentGame.game_code;
          const checkKey = `${game_code}|${realPath}|${history.location.search || ''}`;
          if (pathPermissionCheckKeyRef.current === checkKey) {
            return;
          }
          pathPermissionCheckKeyRef.current = checkKey;
          const {type: page_type, value: page_value} = findPathTypeAndValue(realPath);
          const fallbackUrl = findDashboard
            ? `/dashboard/game/${game_code}/${getPathFromDashboard(findDashboard)}`
            : `/dashboard/game/${game_code}/`;
          checkPathValidity(game_code, page_type, page_value).then((noValid)=>{
            if (noValid) {
              setModalInfo({
                show: true,
                type: '',
                editType: 'access_denied',
                item: {
                  url: fallbackUrl,
                },
              });
            } else if (findDashboard) {
              history.replace(fallbackUrl);
            }
          });
        };
      }
    }
  };

  const checkPathValidity = (game_code:string, page_type:string, page_value:string) => {
    return getPathValidity({
      game_code,
      page_type,
      page_value,
    }).then((response) => {
      const noValid = (response.has_page_data && !response.has_permission) || false;
      return noValid;
    }).catch(() => {
      return false;
    });
  };

  // 点击下载指引
  const handleClickDownload = () => {
    window.open(DOWNLOAD_GUIDE_LINK);
    // 选中样式
    setActiveIndex('3');
  };

  const footerLinkConfig = useMemo(
    () => getFooterLinkConfig(currentGame?.game_code),
    [currentGame?.game_code],
  );

  const footerLinkTooltip = useMemo(() => {
    if (!footerLinkConfig) {
      return '';
    }
    return getLanguage(isEN, footerLinkConfig.tooltip.en, footerLinkConfig.tooltip.cn);
  }, [footerLinkConfig, isEN]);

  const handleClickFooterLink = (): void => {
    if (!footerLinkConfig) {
      return;
    }
    setActiveIndex('4');
    openFooterLink(footerLinkConfig, { gameCode: currentGame?.game_code });
  };

  // 订阅页面跳转
  const handleClickSubscribe = () => {
    history.push(`/dashboard/game/${currentGame?.game_code}/subscribe/subscribeManage`);
    // 选中样式
    setActiveIndex('2');
  };

  const handleClickEvent = () => {
    // 默认就近30天数据, 包括今天, 往前取30天.
    const today = moment(Date.now()).format('YYYY-MM-DD');
    const thirtyDays = moment(today).subtract(30, 'day').format('YYYY-MM-DD');
    history.push(
      `/dashboard/game/${currentGame?.game_code}/eventAnalysis/eventDetails?date=${today}&startDate=${thirtyDays}&timeType=Month&dashboardType=all&fromPage=${history?.location?.pathname}`,
    );
    // 选中样式
    setActiveIndex('1');
  };

  const findGameCode = (gameCode: string, gameList: Array<any>): any => {
    let currentGameCode = null;
    gameList.some((item) => {
      const { game_List: subGameList } = item;
      if (subGameList.length > 0) {
        // 先从子列表查找
        return subGameList.some((subItem: any) => {
          if (
            (gameCode && subItem?.game_code === gameCode) ||
            (!gameCode && subItem?.is_access)
          ) {
            currentGameCode = subItem?.game_code;
            return true;
          }
          return false;
        });
      } else {
        if (
          (gameCode && item?.game_code === gameCode) ||
          (!gameCode && item?.is_access)
        ) {
          currentGameCode = item?.game_code;
          return true;
        }
        return false;
      }
    });
    return currentGameCode;
  };
  // 页面驱动
  useEffect(() => {
    const { system, urlId, realPath } = parseUrlInfo(location.pathname);
    const currentCheckKey = currentGame
      ? `${currentGame.game_code}|${realPath}|${location.search || ''}`
      : '';
    if (pathPermissionCheckKeyRef.current !== currentCheckKey) {
      pathPermissionCheckKeyRef.current = '';
    }
    if (!currentGame) {
      return;
    }
    // 处理/斜杠路由,或者路由中的gamecode不存在
    if (!urlId || (urlId && !findGameCode(urlId, gameList))) {
      if (currentGame) {
        // 重置路由
        history.replace(`/${system}/game/${currentGame.game_code}`);
      }
      return;
    }
    // 游戏初始化关闭遮挡层（解决点击相同游戏页面滚动失败）
    dispatch({
      type: 'dashboard/save',
      payload: {
        showContentMask: false,
      },
    });

    dispatch({
      type: 'home/save',
      payload: {
        showGlobalMask: false,
      },
    });

    // 切换游戏
    if (urlId !== currentGame.game_code) {
      dispatch({
        type: 'dashboard/changeGame',
        payload: {
          gameCode: urlId,
        },
      });
      return;
    }

    // menu 正在请求的时候
    if (menuLoading) {
      return;
    }

    // 没有获取菜单的情况
    if (!menuList) {
      dispatch({
        type: 'dashboard/getLeftMenuList',
        payload: {
          currentGame,
        },
      });
      return;
    }

    // 没有详细路径的情况,重定向到第一个dashboard
    if (!realPath) {
      const findDashboard = findInnerDashboard(dashboardList);
      if (findDashboard) {
        history.replace(
          `/${system}/game/${currentGame.game_code}/${getPathFromDashboard(
            findDashboard,
          )}`,
        );
      }
      return;
    }

    // 设置menu
    checkMenuWitchPath();
  }, [location.pathname, location.search, currentGame, menuList, menuLoading]);

  const { role_id: roleId = '', is_access: isAccess } = currentGame || {};

  const handleCloseModal = () => {
    if (modalInfo.editType === 'access_denied') {
      const { system, realPath } = parseUrlInfo(location.pathname);
      const fallbackUrl = modalInfo?.item?.url;
      const findDashboard = findInnerDashboard(dashboardList, realPath);
      if (fallbackUrl) {
        history.replace(fallbackUrl);
      } else if (findDashboard) {
        history.replace(
          `/${system}/game/${currentGame.game_code}/${getPathFromDashboard(findDashboard)}`,
        );
      } else {
        history.replace(`/${system}/game/${currentGame.game_code}/`);
      }
      
      document.querySelector(".dbd-menu-access-denied-blank")?.remove();
    }

    setModalInfo({
      ...modalInfo,
      show: false,
    });
  };

  const handleExitModal = () => {
    setModalInfo({
      ...initModalInfo,
    });
  };

  const setModalInfoState = (info = {}) => {
    setModalInfo({
      ...initModalInfo,
      ...info,
    });
  };
  
  return (
    <div className='dbd-left-menu-container'>
      <HomeLeftMenu 
        title={title}
        menuList={menuList}
        customHeaderElement={
          <HeaderNav /> 
        }
        // eslint-disable-next-line react/no-children-prop
        children={
          <NavigaMenu
            setModalInfoState={setModalInfoState}
            setActiveIndex={setActiveIndex}
            isAccess={!(gameList.length < 1 || !currentGame || !currentGame.is_access)}
          />
        }
        customFooter={
          <div className="navmenu-ft-left">
            {isAccess && MENU_CONTROL_PERMISSION.includes(roleId) && (
              <Popover
                placement="top-start"
                trigger="click"
                onVisibleChange={()=>{}}
                overlay={
                  <div className="left-nav-exit">
                    <List type="option">
                      <List.Item
                        onClick={() => {
                          setModalInfoState({ editType: 'dashboard', show: true });
                        }}
                      >
                        {formatMessage({ id: 'menu_new_dashboard' })}
                      </List.Item>
                      <List.Item
                        onClick={() => {
                          setModalInfoState({ editType: 'subfolder', show: true });
                        }}
                      >
                        {formatMessage({ id: 'menu_new_subfolder' })}
                      </List.Item>
                      <List.Item
                        onClick={() => {
                          setModalInfoState({ editType: 'folder', show: true });
                        }}
                      >
                        {formatMessage({ id: 'menu_new_folder' })}
                      </List.Item>
                      {MENU_PERMISSION.includes(roleId) && (
                        <List.Item
                          onClick={() => {
                            setModalInfoState({ editType: 'menu', show: true });
                          }}
                        >
                          {formatMessage({ id: 'menu_new_menu' })}
                        </List.Item>
                      )}
                    </List>
                  </div>
                }
              >
                <Bubble content={formatMessage({ id: 'menu_new' })} dark>
                  <div className="dtb-foot-icon-wrap">
                    <SvgIcon type="cross" className={activeIndex==='0'?'navmenu-ft-active':'navmenu-ft-icon'} />
                  </div>
                </Bubble>
              </Popover>
            )}
            {/* 事件分析 START */}
            <Bubble
              content={formatMessage({ id: 'event_left_menu_management' })}
              dark
            >
              <div className="dtb-foot-icon-wrap" onClick={handleClickEvent}>
                <SvgIcon type="subscribe-icon" className={activeIndex==='1'?'navmenu-ft-active':'navmenu-ft-icon'} />
              </div>
            </Bubble>
            {/* 事件分析 END */}

            {/* 订阅 START */}
            {
              subscribleEnable && <Bubble
                content={formatMessage({ id: 'subscribe_left_menu_management' })}
                dark
              >
                <div className="dtb-foot-icon-wrap" onClick={handleClickSubscribe}>
                  <SvgIcon type="flag-plus" className={activeIndex==='2'?'navmenu-ft-active':'navmenu-ft-icon'} />
                </div>
              </Bubble>
            }
            {/* 下载指引 START */}
            {
              SHOW_DOWNLOAD_GUIDE && (
                <Bubble content={formatMessage({ id: 'menu_download' })} dark>
                  <div className="dtb-foot-icon-wrap" onClick={handleClickDownload}>
                    <SvgIcon type="download" className={'navmenu-ft-icon'} />
                  </div>
                </Bubble>
              )
            }
            {/* 下载指引 END */}
            {footerLinkConfig && (
              <Bubble
                content={footerLinkTooltip}
                dark
              >
                <div className="dtb-foot-icon-wrap" onClick={handleClickFooterLink}>
                  <SvgIcon
                    type={footerLinkConfig.icon}
                    className={'navmenu-ft-icon'}
                  />
                </div>
              </Bubble>
            )}
          </div>
        }
        customFooterShrink={
          <div className='dbi-left-menu-footer-warp'>
            <Bubble
              content={formatMessage({ id: 'event_left_menu_management' })}
              dark
            >
              <div className="dtb-foot-icon-wrap" onClick={handleClickEvent}>
                <SvgIcon type="subscribe-icon" className={activeIndex==='1'?'navmenu-ft-active':'navmenu-ft-icon'} />
              </div>
            </Bubble>
          </div>
        }
      />
      {
        // 解决挂载的modal未销毁问题
        modalInfo?.show && <ModalWrap
          modalInfo={modalInfo}
          close={handleCloseModal}
          exit={handleExitModal}
        />
      }

    </div>
  );
});

export default connect((state: any) => {
  const { loading, dashboard } = state;
  return {
    gameList: dashboard.gameList,
    currentGame: dashboard.currentGame,
    currentMenu: dashboard.currentMenu,
    menuList: dashboard.menuList,
    dashboardList: dashboard.dashboardList,
    showContentMask: dashboard.showContentMask,
    subscribleEnable: state?.dashboardSetting?.gameConfig?.subscrible_enable,
    menuLoading: loading.effects['dashboard/getLeftMenuList'],
  };
})(LeftMenu);
